module.exports = "https://r.nearpod.com/assets/media/image/timer-icon-76585a43d84ce174f4819b9d87082072.svg";